import React, { useEffect, useState } from "react";
import { Button } from "@mui/material";
import getDownloadUrl from "../data/getDownloadUrl";
import { getUserUuid } from "../../../auth/AuthUtils";
import axios from "axios";
import { useStore } from "react-admin";

const DownloadButton: React.FC<{ file: FileV2 }> = ({ file }) => {

    const [ isDownloading, setIsDownloading ] = useState(false);
    const [ selectedProject ] = useStore<string>("selected-project");

    useEffect(() => {
        setIsDownloading(false);
    }, []);

    const download = () => {
        setIsDownloading(true);
        const userUuid = getUserUuid() || "";
        getDownloadUrl(selectedProject, userUuid, file.serverFile.relativeLocation)
            .then(result => result.data)
            .then(result => {
                axios
                    .get(result.downloadUrl, {
                        responseType: "blob"
                    })
                    .then(result => {
                        const element = window.document.createElement("a");
                        element.href = window.URL.createObjectURL(
                            new Blob([ result.data ]),
                        );
                        element.download = file.filename;
                        document.body.appendChild(element);
                        element.click();
                        document.body.removeChild(element);
                        setIsDownloading(false);
                    });
            });
    };

    return (
        <Button onClick={() => download()} disabled={isDownloading}>Download</Button>
    );
};

export default DownloadButton;